var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8"},[_c('Heading',{attrs:{"title":"Plan","subTitle":"Superchargify comes with all-inclusive plans."}})],1)]),_c('PlanSelector')],1)}
var staticRenderFns = []

export { render, staticRenderFns }